export enum CreateCaseTarget {
	WORKPLACE_MEMBER = 'WORKPLACE_MEMBER',
	WORKPLACE = 'WORKPLACE',
}
